// jQuery('document').ready(function ($) {
//   if($('.categories').length > 0) {
//     let categories = $('.categories__elem');
//     console.log(categories);
//     // categories.on('mouseenter', function() {
//     //     let elem = $(this);
//     //     let elemChild = $(this).find('.categories__elem_img');
//     //     let key = elem.data('key');
//     //     console.log(elemChild);
//     //     if(categories.length == 4) {
//     //       switch(key) {
//     //           case 0:
//     //               elem.css('transform', 'translate3d(5vw, 0px, 0px) scale(1.5)');
//     //               elemChild.css('transform', 'translate3d(-50%, -50%, 0px) scale3d(0.75, .75, 1)');
//     //               // elemChild.css('transform', 'translate3d(-25%, -5%, 0px) scale3d(0.75, .75, 1)');
//     //               // elemChild.css('transform', 'translate3d(-25%, -5%, 0px) scale3d(1,1, 1)');
//     //               $('.categories__elem_1').css('transform', 'translate3d(10vw, 0px, 0px) scale(1)');
//     //               $('.categories__elem_2').css('transform', 'translate3d(10vw, 0px, 0px) scale(1)');
//     //               $('.categories__elem_3').css('transform', 'translate3d(10vw, 0px, 0px) scale(1)');
//     //               break;
//     //           case 1:
//     //               elem.css('transform', 'translate3d(0px, 0px, 0px) scale(1.5)');
//     //               elemChild.css('transform', 'translate3d(-50%, -50%, 0px) scale3d(0.75, .75, 1)');
//     //               // elemChild.css('transform', 'translate3d(-25%, -5%, 0px) scale3d(0.75, .75, 1)');
//     //               // elemChild.css('transform', 'translate3d(-25%, -5%, 0px) scale3d(1,1, 1)');
//     //               $('.categories__elem_0').css('transform', 'translate3d(-5vw, 0px, 0px) scale(1)');
//     //               $('.categories__elem_2').css('transform', 'translate3d(5vw, 0px, 0px) scale(1)');
//     //               $('.categories__elem_3').css('transform', 'translate3d(5vw, 0px, 0px) scale(1)');
//     //               break;
//     //           case 2:
//     //               elem.css('transform', 'translate3d(0px, 0px, 0px) scale(1.5)');
//     //               elemChild.css('transform', 'translate3d(-50%, -50%, 0px) scale3d(0.75, .75, 1)');
//     //               // elemChild.css('transform', 'translate3d(-25%, -5%, 0px) scale3d(0.75, .75, 1)');
//     //               // elemChild.css('transform', 'translate3d(-25%, -5%, 0px) scale3d(1,1, 1)');
//     //               $('.categories__elem_0').css('transform', 'translate3d(-5vw, 0px, 0px) scale(1)');
//     //               $('.categories__elem_1').css('transform', 'translate3d(-5vw, 0px, 0px) scale(1)');
//     //               $('.categories__elem_3').css('transform', 'translate3d(5vw, 0px, 0px) scale(1)');
//     //               break;
//     //           case 3:
//     //               elem.css('transform', 'translate3d(-5vw, 0px, 0px) scale(1.5)');
//     //               elemChild.css('transform', 'translate3d(-50%, -50%, 0px) scale3d(0.75, .75, 1)');
//     //               // elemChild.css('transform', 'translate3d(-25%, -5%, 0px) scale3d(0.75, .75, 1)');
//     //               // elemChild.css('transform', 'translate3d(-25%, -5%, 0px) scale3d(1,1, 1)');
//     //               $('.categories__elem_0').css('transform', 'translate3d(-10vw, 0px, 0px) scale(1)');
//     //               $('.categories__elem_1').css('transform', 'translate3d(-10vw, 0px, 0px) scale(1)');
//     //               $('.categories__elem_2').css('transform', 'translate3d(-10vw, 0px, 0px) scale(1)');
//     //               break;
//     //       }
//     //     } else if(categories.length == 3) {
//     //       switch(key) {
//     //         case 0:
//     //             elem.css('transform', 'translate3d(5vw, 0px, 0px) scale(1.3)');
//     //             elemChild.css('transform', 'translate3d(-50%, -50%, 0px) scale3d(0.55, .55, 1)');
//     //             // elemChild.css('transform', 'translate3d(-25%, -5%, 0px) scale3d(0.75, .75, 1)');
//     //             // elemChild.css('transform', 'translate3d(-25%, -5%, 0px) scale3d(1,1, 1)');
//     //             $('.categories__elem_1').css('transform', 'translate3d(10vw, 0px, 0px) scale(1)');
//     //             // $('.categories__elem_2').css('transform', 'translate3d(10vw, 0px, 0px) scale(1)');
//     //             $('.categories__elem_2').css('transform', 'translate3d(10vw, 0px, 0px) scale(1)');
//     //             break;
//     //         case 1:
//     //             elem.css('transform', 'translate3d(0px, 0px, 0px) scale(1.3)');
//     //             elemChild.css('transform', 'translate3d(-50%, -50%, 0px) scale3d(0.75, .75, 1)');
//     //             // elemChild.css('transform', 'translate3d(-25%, -5%, 0px) scale3d(0.75, .75, 1)');
//     //             // elemChild.css('transform', 'translate3d(-25%, -5%, 0px) scale3d(1,1, 1)');
//     //             $('.categories__elem_0').css('transform', 'translate3d(-5vw, 0px, 0px) scale(1)');
//     //             $('.categories__elem_2').css('transform', 'translate3d(5vw, 0px, 0px) scale(1)');
//     //             // $('.categories__elem_3').css('transform', 'translate3d(5vw, 0px, 0px) scale(1)');
//     //             break;
//     //         case 2:
//     //             elem.css('transform', 'translate3d(0px, 0px, 0px) scale(1.3)');
//     //             elemChild.css('transform', 'translate3d(-50%, -50%, 0px) scale3d(0.75, .75, 1)');
//     //             // elemChild.css('transform', 'translate3d(-25%, -5%, 0px) scale3d(0.75, .75, 1)');
//     //             // elemChild.css('transform', 'translate3d(-25%, -5%, 0px) scale3d(1,1, 1)');
//     //             $('.categories__elem_0').css('transform', 'translate3d(-5vw, 0px, 0px) scale(1)');
//     //             $('.categories__elem_1').css('transform', 'translate3d(-5vw, 0px, 0px) scale(1)');
//     //             // $('.categories__elem_3').css('transform', 'translate3d(5vw, 0px, 0px) scale(1)');
//     //             break;
//     //       }
//     //     }
//     // });
//     // categories.on('mouseleave', function() {
//     //     let elem = $(this);
//     //     let elemChild = $(this).find('.categories__elem_img');
//     //     let key = elem.data('key');
//     //     console.log(elemChild);
//     //     if(categories.length == 4) {
//     //       switch(key) {
//     //           case 0:
//     //               elem.css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //               // elemChild.css('transform', 'translate3d(-25%,-5%,0) scale3d(1,1,1)');
//     //               elemChild.css('transform', 'translate3d(-50%,-50%,0) scale3d(1,1,1)');
//     //               $('.categories__elem_1').css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //               $('.categories__elem_2').css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //               $('.categories__elem_3').css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //               break;
//     //           case 1:
//     //               elem.css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //               elemChild.css('transform', 'translate3d(-50%,-50%,0) scale3d(1,1,1)');
//     //               $('.categories__elem_0').css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //               $('.categories__elem_2').css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //               $('.categories__elem_3').css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //               // elem.css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //               // elemChild.css('transform', 'translate3d(-25%,-5%,0) scale3d(1,1,1)');
//     //               // $('.categories__elem_0').css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //               // $('.categories__elem_2').css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //               // $('.categories__elem_3').css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //               break;
//     //           case 2:
//     //               elem.css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //               elemChild.css('transform', 'translate3d(-50%,-50%,0) scale3d(1,1,1)');
//     //               $('.categories__elem_0').css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //               $('.categories__elem_1').css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //               $('.categories__elem_3').css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //               // elem.css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //               // elemChild.css('transform', 'translate3d(-25%,-5%,0) scale3d(1,1,1)');
//     //               // $('.categories__elem_0').css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //               // $('.categories__elem_1').css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //               // $('.categories__elem_3').css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //               break;
//     //           case 3:
//     //               elem.css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //               // elemChild.css('transform', 'translate3d(-25%,-5%,0) scale3d(1,1,1)');
//     //               elemChild.css('transform', 'translate3d(-50%,-50%,0) scale3d(1,1,1)');
//     //               $('.categories__elem_0').css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //               $('.categories__elem_1').css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //               $('.categories__elem_2').css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //               break;
//     //       }
//     //     } else if(categories.length == 3) {
//     //       switch(key) {
//     //         case 0:
//     //             elem.css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //             // elemChild.css('transform', 'translate3d(-25%,-5%,0) scale3d(1,1,1)');
//     //             elemChild.css('transform', 'translate3d(-50%,-50%,0) scale3d(1,1,1)');
//     //             $('.categories__elem_1').css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //             $('.categories__elem_2').css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //             $('.categories__elem_3').css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //             break;
//     //         case 1:
//     //             elem.css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //             elemChild.css('transform', 'translate3d(-50%,-50%,0) scale3d(1,1,1)');
//     //             $('.categories__elem_0').css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //             $('.categories__elem_2').css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //             $('.categories__elem_3').css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //             // elem.css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //             // elemChild.css('transform', 'translate3d(-25%,-5%,0) scale3d(1,1,1)');
//     //             // $('.categories__elem_0').css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //             // $('.categories__elem_2').css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //             // $('.categories__elem_3').css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //             break;
//     //         case 2:
//     //             elem.css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //             elemChild.css('transform', 'translate3d(-50%,-50%,0) scale3d(1,1,1)');
//     //             $('.categories__elem_0').css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //             $('.categories__elem_1').css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //             $('.categories__elem_3').css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //             // elem.css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //             // elemChild.css('transform', 'translate3d(-25%,-5%,0) scale3d(1,1,1)');
//     //             // $('.categories__elem_0').css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //             // $('.categories__elem_1').css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //             // $('.categories__elem_3').css('transform', 'translate3d(0px, 0px, 0px) scale(1)');
//     //             break;
//     //       }
//     //     }
//     // });
//   }
// });
